import { addMinutes } from "date-fns/addMinutes";

export function getMinimumEventEnd(start: Date): Date {
  return addMinutes(start, 30);
}
